import localStorage from '@/utils/localStorage'

const SELECTED_ORG_LIKE_TEAM_KEY = 'selectedOrgLikeTeamId'

export default {
  namespaced: true,
  state: () => ({
    selectedOrgLikeTeamId: parseInt(localStorage.getItem(SELECTED_ORG_LIKE_TEAM_KEY)) || null
  }),
  getters: {
    selectedOrgLikeTeamId: (state, getters, rootState, rootGetters) => {
      const selectedOrgLikeTeamId = state.selectedOrgLikeTeamId
      return selectedOrgLikeTeamId &&
        rootGetters.user.teams?.find(team => team.id === selectedOrgLikeTeamId)
        ? selectedOrgLikeTeamId
        : null
    }
  },
  mutations: {
    SET_SELECTED_ORG_LIKE_TEAM_ID(state, teamId) {
      if (typeof teamId === 'string') {
        teamId = parseInt(teamId)
      }
      if (isNaN(teamId)) {
        throw new Error('Cannot select a NaN teamId')
      }
      state.selectedOrgLikeTeamId = teamId
      localStorage.setItem(SELECTED_ORG_LIKE_TEAM_KEY, teamId)
    },
    CLEAR_SELECTED_ORG_LIKE_TEAM_ID(state) {
      state.selectedOrgLikeTeamId = null
      localStorage.removeItem(SELECTED_ORG_LIKE_TEAM_KEY)
    }
  },
  actions: {
    select({ commit }, { subOrgId }) {
      commit('SET_SELECTED_ORG_LIKE_TEAM_ID', subOrgId)
    },
    clear({ commit }) {
      commit('CLEAR_SELECTED_ORG_LIKE_TEAM_ID')
    }
  }
}
